// extracted by mini-css-extract-plugin
module.exports = {"creativeCommons":"BlogCreativeCommons_creativeCommons__4dN_N","link":"BlogCreativeCommons_link__HxJ36","icon":"BlogCreativeCommons_icon__3vrsQ"};